<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
       <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="phone" slot-scope="phone">
          <div>
            <div class="font-weight-bold">{{phone}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="address" slot-scope="address">
          <div>{{address}}</div>
        </template>
        <template slot="email_id" slot-scope="email_id">
          <span class="font-weight-bold">{{email_id}}</span>
        </template>
        <template slot="privacy_policy" slot-scope="privacy_policy">
          <span class="font-weight-bold">{{privacy_policy}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-board ref="editPrivacyPolicy" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <editPrivacyPolicy ref="editPrivacyPolicy" @edited="handleEdited"/>
  </div>
</template>
<script>
import editPrivacyPolicy from '@/components/schoolPrivacyPolicy/Forms/Edit/index'

const columns = [

  {
    title: 'Phone',
    dataIndex: 'phone',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'phone' },
    sorter: (a, b) => a.phone.length - b.phone.length,
  },
  {
    title: 'Address',
    dataIndex: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: 'Email',
    dataIndex: 'email_id',
    key: 'email_id',
    scopedSlots: { customRender: 'email_id' },
  },
  {
    title: 'Privacy-Policy',
    dataIndex: 'privacy_policy',
    scopedSlots: { customRender: 'privacy_policy' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'EditPrivacyPolicy',
  components: {
    editPrivacyPolicy,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editPrivacyPolicy.showModal(record.id)
      this.$eventBus.$emit('openPolicyEditModel', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete Privacy Policy ?',
        content: 'Click Yes to delete Privacy Policy !',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/privacy/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Policy has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
            // this.$router.go()
          this.$router.push({ name: 'schools' })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
